import { NegotiationBoundary } from '@procureai/schemas';
import { map } from 'ramda';

import {
  TsrctNegotiationStrategyBoundary,
  TsrctNegotiationStrategyBoundaryBase,
  TsrctNegotiationStrategyBoundaryRuleInput,
} from '@/generated/gql/graphql';

export const mapSortTsrctNegotiationStrategyBoundaries = map<TsrctNegotiationStrategyBoundary, NegotiationBoundary>(
  ({ id, base, lower, upper, sequence }) => ({
    id,
    sequence,
    base,
    lower: Number(lower),
    upper: Number(upper),
  }),
);

export const mapToTsrctNegotiationStrategyBoundaryRuleInput = map<
  NegotiationBoundary,
  TsrctNegotiationStrategyBoundaryRuleInput
>(({ base, lower, upper }) => ({
  lower: lower.toString(),
  upper: upper.toString(),
  base: TsrctNegotiationStrategyBoundaryBase[base],
}));
